import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EventService } from "../../Services/event.service";

@Component({
  selector: "app-journey-view-activity",
  templateUrl: "./journey-view-activity.component.html",
  styleUrls: ["./journey-view-activity.component.css"],
})
export class JourneyViewActivityComponent implements OnInit {

  @Input() activity;

  @Input() index_j;

  @Input() paceEnabled;

  @Input() index;

  @Output() closeSidebar = new EventEmitter<any>();

  sub: any;
  pageName = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router, private eventService: EventService) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      if (params["activity"]) {
        this.pageName = params["page"];
      }
    });
  }
  truncateString(activityName)
  {
    if(activityName.length>32)
    {
      return activityName.substring(0,33)+'...';
    }
      return activityName
  }
  routeToActivity(activity)
  {
    console.log(activity["isRecent"]);
    if(activity['isArchived'])
    {
      let eventName = "Click Obsolete Activity";
      let computedProperties = {
        "activity_name":activity['activityName'],
        "trigger_location":"activity list - sidebar"
      };
      this.eventService.track(eventName,computedProperties);
      let url = "/archived/page/" + this.pageName + "/activity/" + activity['id'];
      this.router.navigateByUrl(url);
    } else {
      let url = "/journey/page/" + this.pageName + "/activity/" + activity["id"];
      this.router.navigateByUrl(url);
    }
    this.closeSidebar.emit(true);
  }
}
